<template>
    <div>
        <div>
            <div class="w3-col">
                <content-header v-bind:title="$t('physicians')"></content-header>
                <div v-if="isCurrentUserAdmin()" class="w3-right w3-margin-right flow-margin-top">
                    <i class="fa fa-plus flow-blue-color w3-xlarge cursor-pointer w3-margin-right" @click="openNewForm = true"></i>
                </div>
            </div>
        </div>


        <div class="content-sidebars sidebars-70-30">
            <!--        Add new physician form-->
            <div v-if="openNewForm" class="w3-container content-sidebar-right">
                <i class="fa fa-times cursor-pointer w3-xlarge w3-text-gray flow-margin-top" @click="openNewForm = false"></i>
                <new-physician :onClose="() => {openNewForm = false}"></new-physician>
            </div>

            <!--            Physicians list-->
            <div v-bind:class="openNewForm ? 'content-sidebar-left' : ''">
                <physicians-list></physicians-list>
            </div>
        </div>
    </div>
</template>
<script>
    import ContentHeader from "../components/common/ContentHeader";
    import Loading from "../components/common/Loading";
    import Vue from 'vue';
    import PhysiciansList from "../components/physician/PhysiciansList";
    import NewPhysician from "../components/physician/NewPhysician";

    let frc = Vue.prototype.$frc;

    export default {
        name: "Physicians",
        components: {NewPhysician, PhysiciansList, Loading, ContentHeader},
        props: ['ftitle'],
        data() {
            return {
                openNewForm: false
            }
        }
    }

</script>

<style scoped>

</style>